import axiosInstance from '@/api/axiosInstance';
import { SaveModuleContentBlocksRequest, SaveModuleContentBlocksResponse } from './types';

/**
 * Save (replace) all content blocks for a specific module
 * PUT /api/learning-center/modules/{moduleId}/content-blocks
 *
 * This is a full replacement operation - all existing blocks are replaced
 * with the provided set.
 *
 * @param request - Request payload containing moduleId and contentBlocks array
 * @returns Promise with saved content blocks
 * @throws Error if validation fails (400), module not found (404), or request fails
 */
export const saveModuleContentBlocks = async (
  request: SaveModuleContentBlocksRequest
): Promise<SaveModuleContentBlocksResponse> => {
  try {
    const response = await axiosInstance.put<SaveModuleContentBlocksResponse>(
      `/api/learning-center/modules/${request.moduleId}/content-blocks`,
      { contentBlocks: request.contentBlocks }
    );
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      console.error(`Module with ID ${request.moduleId} not found`);
      throw new Error(`Module with ID ${request.moduleId} not found`);
    }

    if (error.response?.status === 400) {
      // Validation error - extract details
      const errorData = error.response.data;
      const errorMessage = errorData?.error || 'Validation error';
      console.error('Validation error saving content blocks:', errorData);
      throw new Error(errorMessage);
    }

    console.error('Error saving module content blocks:', error);
    throw error;
  }
};
